import { Component, AfterViewInit, Input, OnInit, ElementRef, ViewChild, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { Dropdown } from '@eds/vanilla/dropdown/Dropdown';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import * as _ from 'lodash';
import { saveAs } from 'file-saver';
import {Donut} from '@eds/vanilla/charts/donut/Donut';
import { LineChart} from '@eds/vanilla/charts/line-chart/LineChart';

import {applicationUsageDataService} from '../service/applicationUsage.data.service';
declare var jQuery: any;
@Component({
  selector: 'app-data-applications-component',
  templateUrl: './data-applications-component.component.html',
  styleUrls: ['./data-applications-component.component.css']
})
export class DataApplicationsComponentComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() dataFiltered: string;

  @ViewChild('appoverviewdrop', {static: false})
  private appoverviewMenu: ElementRef;

  @ViewChild('appdailytrenddrop', {static: false})
  private appdailytrendMenu: ElementRef;

  @ViewChild('appinventorydrop', {static: false})
  private appinventoryMenu: ElementRef;

  isSorted = false;
  sortedClass: string;
  propertyName: string;
  propertyNameSorting: string;
  orderType = true;
  userListData: any[] = [];
  fontBig = '64px';
  fontSmall = '44px';
  appOverviewData = [];
  edsAppicationData1:any;  
  lineChartData:any;
  isLineChartLoaded = false;
  isDonutChartLoaded = false;
  appOverviewSetting = {
    selector: 'appOverviewChart',
    width: 203,
    height: 203,
    hole: 90,
    colors : ['#bf93db', '#813aa1', '#3f1f4d'],
    total: 'sum',
    totalText: 'App Use (hours)'
  };

  appUseTrendChartData = [];

  appUseTrendChartSetting = {
    selector: 'appUseTrendChart',
    width: 800,
    height: 280,
    colors : ['#8c60a8', '#bf93db', '#e8d6f2']
  };
  seriesData:any;
  commonData:any;
  sumofApplicationItems: any = [];
  applicationData: any;
  order = 'info.name';
  reverse = false;
  inventoryReport: any;
  inventoryData: any = [];
  sumofAppInventoryData: any = [];

  subscription = [];
  textDir:any;
  constructor( private applicationUsageService: applicationUsageDataService ) { 
    this.textDir =  sessionStorage.getItem('textDir');
  }

  ngOnInit() {
    this.loadAllSectionsData();
  }

  ngOnDestroy() {
    this.subscription.forEach(sub => {
      sub.unsubscribe();
    });
  }
  ngDoCheck() {
    
    if (document.getElementById('applineChart')){
      if (!this.isLineChartLoaded && document.getElementById('applineChart').clientHeight > 0){
        document.getElementById('applineChart').innerHTML = '';
       //console.log("application tab");
        this.linechartInit();
        setTimeout(function(){​​​​ 
          jQuery('#applineChart').find('rect').attr('pointer-events','none');
        }​​​​, 1000);
        this.isLineChartLoaded = true;
      }
    } 
  }

  ngAfterViewInit() {
    this.chartComponentsInit();
  }
chartComponentsInit(){
  const appoverviewDrop = new Dropdown(this.appoverviewMenu.nativeElement);
    appoverviewDrop.init();

    const appdailytrendDrop = new Dropdown(this.appdailytrendMenu.nativeElement);
    appdailytrendDrop.init();

    const appinventoryDrop = new Dropdown(this.appinventoryMenu.nativeElement);
    appinventoryDrop.init();
}

  donutChartInit_01(){
    document.getElementById('appdonut').innerHTML="";
    const chart1 = new Donut({
      element: document.getElementById('appdonut'),
      data: this.edsAppicationData1,     
      showValue: true,
      showAbsoluteValue:true,
      unit: 'App Use (hours)'
    });
    chart1.init();
   
  }

  linechartInit(){   
    document.getElementById('applineChart').innerHTML="";
    const linechart01 = new LineChart({
      element: document.getElementById('applineChart'),
      data: this.lineChartData,
      height: 250,
      margin: {
        left: 35,
      },
      y: {
        unit: 'Number of users',
      }
    });
    
   linechart01.init();
    
  }
  
  loadAllSectionsData() {
      this.applicationUsageService.getApplicationOverviewData();
      this.applicationUsageService.getApplicationDailyTrendData();
      // all data subscription
      this.getApplicationOverview();
      this.getApplicationOverviewTab();
      this.getApplicationDailyTrend();
      this.getApplicationInventory();
  }

  getApplicationOverview() {
    const sub = this.applicationUsageService.applicationOverview$Data.subscribe(data => {
      this.appOverviewData = [...data];
      const edsDataObj3 = [];
        this.appOverviewData.forEach((a,index) => {
          const dataObj1 = {name: a.id, values: [a.count], colorID: (index+1).toString()};
          edsDataObj3.push(dataObj1);
        });
        // edsDataObj.push({name: 'test', value: ['300'], colorID: '3'});
       // this.edsAppicationData1 = {series: edsDataObj3};
        const nodataObj2 = [{name:"Internet explorer",values:[200],colorID:"1"},{name:"Cygwin",values:[120],colorID:"2"},{name:"Gitbash",values:[40],colorID:"3"}]
        
      if(this.appOverviewData.length>0){
        this.edsAppicationData1 = {"series": edsDataObj3};

      }else{

        this.edsAppicationData1 = {"series": nodataObj2};
      }
      this.donutChartInit_01();
    });

      
    this.subscription.push(sub);

  }

  getApplicationOverviewTab() {
    const sub = this.applicationUsageService.applicationOverviewTab$Data.subscribe(data => {
      this.sumofApplicationItems = [...data];
      if(this.sumofApplicationItems.length==0){

        this.sumofApplicationItems = [{"id":"Internet Explorer","usage_hours":0,"user_count":0},{"id":"Cygwin","usage_hours":0,"user_count":0},{"id":"Git Bash","usage_hours":0,"user_count":0}]
      }
    });
    this.subscription.push(sub);
  }

  getApplicationDailyTrend() {
    let sArr=[];
    let cArr=[];
    const sub = this.applicationUsageService.applicationDailyTrend$Data.subscribe(data => {
    this.appUseTrendChartData = [...data];
    const commonArr = [];
    let valuesArr = [];
    let idArr = [];   
    this.appUseTrendChartData.forEach((item,index) => {   
      let i = 0;
     for (const items of item.values) {      
        i++;
        valuesArr.push({name:item.id,values:items.count});
        commonArr.push(items.date);      
      }   
      sArr = valuesArr;
      cArr = commonArr;
    });
   
    const seriesArr = this.groupObj(sArr, 'name');   
   //console.log("series Arr >> "+JSON.stringify(seriesArr));
   //console.log("common Arr >> "+JSON.stringify(commonArr));
    let common = ["2018-11-14","2018-11-13","2018-11-12","2018-11-11","2018-11-10"]
    let series = [{name:"CTL Student App",values:["0","10","20","30","40"]},{name:"Internet Explorer", values:["0","10","20","30","40"]},{name:"Other Apps", values:["0","10","20","30","40"]}]
    
    
    if(this.appUseTrendChartData.length>0){
      this.lineChartData = {series: seriesArr, common:cArr};
      /* setTimeout(function(){​​​​ 
        jQuery('#applineChart').find('rect').attr('pointer-events','all');
      }​​​​, 1000); */
    }else{
      this.lineChartData = {series: series, common:common};
      /* setTimeout(function(){​​​​ 
        jQuery('#applineChart').find('rect').attr('pointer-events','none');
      }​​​​, 1000); */
    }
    this.linechartInit();
    });
    this.subscription.push(sub);
  }

 groupObj(array, key){
  var result=_.chain(array).groupBy(key).map(function(v, i) {
    return {
      name: i,    
      values: _.map(v, 'values')
    }
  }).value();
  return result;
 }



  getApplicationInventory() {
    const sub = this.applicationUsageService.applicationInventory$Data.subscribe(data => {
      this.sumofAppInventoryData = [...data];
      if(this.sumofAppInventoryData.length==0){

        this.sumofAppInventoryData = [{"no_of_installs":0,"app_category":"CTL Student App","activity_date":"2019-11-15T00:00:00.000Z","app_version":1,"device_type":"Laptop","os_name":"Android","app_name":"Internet Explorer"},{"no_of_installs":0,"app_category":"CTL Student App","activity_date":"2019-11-15T00:00:00.000Z","app_version":1,"device_type":"Laptop","os_name":"Windows","app_name":"Internet Explorer"},{"no_of_installs":0,"app_category":"CTL Student App","activity_date":"2019-11-11T00:00:00.000Z","app_version":1,"device_type":"Laptop","os_name":"Windows","app_name":"Cygwin"},{"no_of_installs":0,"app_category":"CTL Student App","activity_date":"2019-11-14T00:00:00.000Z","app_version":1,"device_type":"Laptop","os_name":"Windows","app_name":"Internet Explorer"},{"no_of_installs":0,"app_category":"CTL Student App","activity_date":"2019-11-12T00:00:00.000Z","app_version":1,"device_type":"Laptop","os_name":"Windows","app_name":"Cygwin"},{"no_of_installs":0,"app_category":"CTL Student App","activity_date":"2019-11-13T00:00:00.000Z","app_version":1,"device_type":"Tablet","os_name":"Android","app_name":"Git Bash"}]
      }
     //console.log("sumofAppInventoryDatajani >>>> "+JSON.stringify(this.sumofAppInventoryData))
    });
    this.subscription.push(sub);
  }

  sortBy(propertyName){
    this.isSorted = true;
    this.sortedClass = '';
    this.propertyName = propertyName;
    if (propertyName !== null && this.propertyName === propertyName){
      if (this.orderType === true){
        this.orderType = false;
        this.propertyNameSorting = propertyName;
        this.sortedClass = 'glyphicon glyphicon-sort-by-attributes';
      }else{
        this.orderType = true;
        this.propertyNameSorting = '-' + propertyName;
        this.sortedClass = 'glyphicon glyphicon-sort-by-attributes-alt';
      }
    }
  }

  sortTable(tableClass, n) {
    let table;
    let rows;
    let switching;
    let i;
    let x;
    let y;
    let shouldSwitch;
    let dir;
    let switchcount = 0;

    table = document.getElementsByClassName(tableClass)[0];
    switching = true;
    dir = 'asc';
    while (switching) {
      switching = false;
      rows = table.getElementsByTagName('TR');
      for (i = 1; i < (rows.length - 1); i++) {
        shouldSwitch = false;
        x = rows[i].getElementsByTagName('TD')[n];
        y = rows[i + 1].getElementsByTagName('TD')[n];
        const xContent = (isNaN(x.innerHTML)) ? (x.innerHTML.toLowerCase() === '-')
            ? 0 : x.innerHTML.toLowerCase()
          : parseFloat(x.innerHTML);
        const yContent = (isNaN(y.innerHTML))
          ? (y.innerHTML.toLowerCase() === '-')
            ? 0 : y.innerHTML.toLowerCase()
          : parseFloat(y.innerHTML);
        if (dir === 'asc') {
          if (xContent > yContent) {
            shouldSwitch = true;
            break;
          }
        } else if (dir === 'desc') {
          if (xContent < yContent) {
            shouldSwitch = true;
            break;
          }
        }
      }
      if (shouldSwitch) {
        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
        switching = true;
        switchcount ++;
      } else {
        if (switchcount === 0 && dir === 'asc') {
          dir = 'desc';
          switching = true;
        }
      }
     }
  }

  generateCSV(section: any) {
    if (section === 'application-overview') {
      const csv = this._objectArrayToCsv(this.sumofApplicationItems);
      this._downloadFile(section, csv);
    }
    if (section === 'application-trend') {
      let csv = new Array();
      this.appUseTrendChartData.forEach(item => {
        csv.push(item.id);
        csv.push('');
        csv = csv.concat(this._objectArrayToCsv(item.values));
        csv.push('');
      });
      this._downloadFile(section, csv);
    }

    if (section === 'application-inventory') {
      const csv = this._objectArrayToCsv(this.sumofAppInventoryData);
      this._downloadFile(section, csv);
    }
  }

  _downloadFile(section, csv) {
    const csvArray = csv.join('\r\n');
    const blob = new Blob([csvArray], {type: 'text/csv' });
    saveAs(blob, 'overview-' + section + '.csv');
  }

  _objectArrayToCsv(data: any) {
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    const csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    return csv;
  }

}
